// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"index__thumbnail__1WpwC","content":"index__content__2iuxZ","duration":"index__duration__18qKN"};